import React, {useEffect, useState} from 'react'
import {Outlet, useNavigate} from 'react-router-dom'
import styles from './main-layout.module.scss';
import Menu from '../menu';
import {useAppDispatch, useAppSelector} from '../../hooks/hooks';
import { getProfile } from '../../features/profile';
import {getSubscription} from '../../features/billing/subscription';
import {getEmployee} from '../../features/employees/single';
import {BreadcrumbOverrideProvider} from '../breadcrumbs/override-context';
import {LayoutStateProvider} from '../../contexts/layout-context';
import { canSeeSubscriptionSection } from '../../features/profile/navigationVisibility';

export default function MainLayout() {
    const dispatch = useAppDispatch();
    const [appLoading, setAppLoading] = useState(false);
    const {token} = useAppSelector(store => store.auth);
    const profile = useAppSelector(store => store.profile);
    const indicatorLoading = useAppSelector(store => store.indicator.loading);

    const navigate = useNavigate();

    useEffect(() => {
        if (!token) navigate('auth');
        if (profile === undefined || profile.id < 1) {
            setAppLoading(true)
            dispatch(getProfile()).unwrap().then((value) => {
                if (value === undefined) {
                    setAppLoading(false)
                }
                dispatch(getEmployee(value.id))
                if (canSeeSubscriptionSection(value)) {
                    dispatch(getSubscription()).then(() => {
                        setAppLoading(false)
                    })
                } else {
                    setAppLoading(false)
                }
            }).catch(() => {
                // nothing
            })
        }

    }, [])

    return (
        <BreadcrumbOverrideProvider>
            <LayoutStateProvider>
                <div className={styles.mainContainer}>
                    {(appLoading || indicatorLoading) && <div className={styles.globalLoadingBar} aria-hidden='true' />}
                    <Menu loading={appLoading} />
                    <React.Suspense>
                        <div className={styles.mainSubContainer}>
                            { !appLoading && <Outlet /> }
                        </div>
                    </React.Suspense>
                    <div id='modal-timinator'></div>
                </div>
            </LayoutStateProvider>
        </BreadcrumbOverrideProvider>
    )
}
